import { Builder } from '@builder.io/react';

import EnterpriseReady from './index';

Builder.registerComponent(EnterpriseReady, {
  name: 'Enterprise Ready',
  inputs: [
    { name: 'bg', type: 'string', enum: ['bg-black', 'bg-neutral-950', 'bg-neutral-900'] },
    { name: 'overtitle', type: 'string' },
    { name: 'title', type: 'string' },
    { name: 'subtitle', type: 'string' },
    {
      name: 'annotationList',
      type: 'list',
      subFields: [
        {
          name: 'icon',
          type: 'string',
          enum: [
            'cuboid',
            'linesSplines',
            'point',
            'polygon',
            'segmentation',
            'boundingBox',
            'classification',
            'transcription',
            'ner',
            'collection',
            'dataExtraction',
            'audioSpeech',
            'logistics',
            'financialServices',
            'healthcare'
          ]
        },
        { name: 'name', type: 'string' }
      ]
    },
    {
      name: 'task',
      type: 'object',
      subFields: [
        {
          name: 'title',
          type: 'string'
        },
        {
          name: 'text',
          type: 'string'
        }
      ]
    },
    {
      name: 'costEffective',
      type: 'object',
      subFields: [
        {
          name: 'title',
          type: 'string'
        },
        {
          name: 'text',
          type: 'string'
        }
      ]
    }
  ]
});
